import { render, staticRenderFns } from "./createBusBeneficiary.vue?vue&type=template&id=97b2f340&scoped=true&"
import script from "./createBusBeneficiary.vue?vue&type=script&lang=js&"
export * from "./createBusBeneficiary.vue?vue&type=script&lang=js&"
import style0 from "./createBusBeneficiary.vue?vue&type=style&index=0&id=97b2f340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b2f340",
  null
  
)

export default component.exports